// Listado de fichas para oficina: filtros por estado y búsqueda por
// cliente/teléfono, tabla con enlace al detalle.
import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { ESTADO_FICHA, type EstadoFicha } from '@dim/shared';
import { api, ESTADO_LABEL, fechaCorta, type FichaResumen, ApiError } from '../api.js';

export function FichasLista() {
  const [fichas, setFichas] = useState<FichaResumen[]>([]);
  const [estado, setEstado] = useState<EstadoFicha | ''>('');
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function cargar() {
    setLoading(true);
    setError('');
    try {
      const r = await api.listFichas({
        estado: estado || undefined,
        q: q.trim() || undefined,
      });
      setFichas(r.fichas);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Error al cargar las fichas.');
    } finally {
      setLoading(false);
    }
  }

  // Recarga al cambiar el estado seleccionado (la búsqueda va por submit).
  useEffect(() => {
    void cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estado]);

  function onBuscar(e: FormEvent) {
    e.preventDefault();
    void cargar();
  }

  return (
    <section>
      <div className="page-head">
        <h1>Fichas de dimensionado</h1>
        <span className="count">{fichas.length} ficha(s)</span>
      </div>

      <form className="filters" onSubmit={onBuscar}>
        <select value={estado} onChange={(e) => setEstado(e.target.value as EstadoFicha | '')}>
          <option value="">Todos los estados</option>
          {ESTADO_FICHA.map((s) => (
            <option key={s} value={s}>
              {ESTADO_LABEL[s]}
            </option>
          ))}
        </select>
        <input
          type="search"
          placeholder="Buscar por cliente o teléfono…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button type="submit" className="btn-ghost">
          Buscar
        </button>
      </form>

      {error && <p className="login-error">{error}</p>}

      {loading ? (
        <p className="muted">Cargando…</p>
      ) : fichas.length === 0 ? (
        <p className="muted">No hay fichas con esos criterios.</p>
      ) : (
        <table className="grid">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Teléfono</th>
              <th>Técnico</th>
              <th>Estado</th>
              <th>Archivos</th>
              <th>Actualizada</th>
            </tr>
          </thead>
          <tbody>
            {fichas.map((f) => (
              <tr key={f.id}>
                <td>
                  <Link to={`/fichas/${f.id}`}>{f.clienteNombre}</Link>
                </td>
                <td>{f.clienteTelefono}</td>
                <td>{f.tecnicoNombre}</td>
                <td>
                  <span className={`badge estado-${f.estado}`}>{ESTADO_LABEL[f.estado]}</span>
                </td>
                <td>
                  {f.archivosSubidos}/{f.archivosTotal}
                </td>
                <td className="muted">{fechaCorta(f.updatedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
